module.exports = __webpack_public_path__ + "static/media/promocode-bonus-mobile-header-image.db7421fa.png";